import Shared from 'emun.cart/cart.controller'
import resolve from 'ioc/resolve'
import templateUrl from 'emun.cart/cart-ship-location.htm'
import modals from "webmodals/modals";

class CartShipLocationController extends Shared{
    constructor ($cart) {
        super($cart)
        let $stateParams = resolve('$stateParams');
        if ($stateParams.cartId) $cart.load($stateParams.cartId);
  }

  shippingInfoModal() {
    return modals.open({
      templateUrl: "b2c-ship-info.html",
      controllerAs: "$ctrl",
      controller: function ($scope, $uibModalInstance, $session) {
        let $ctrl = this;

        $ctrl.dismiss = $ctrl.cancel = $uibModalInstance.dismiss;
      },
      size: "md"
    }).result;
  }
}

let CartShipLocation = {
    controller: CartShipLocationController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};

export default CartShipLocation;